/** Pulls a real measurement out of a product name ("HK Ribbon 15cm Shelf" → "15 cm"), so cards can show size without inventing data. */
export function sizeFromName(name: string) {
  const match = name.match(/(\d+(?:[.,]\d+)?)\s?(cm|mm)\b/i);
  return match ? `${match[1]} ${match[2]!.toLowerCase()}` : null;
}

/** Category names are typed by hand in admin; soften ALL-CAPS entries ("3D SHELF" → "3D Shelf") for display only. */
export function displayName(name: string) {
  if (name !== name.toUpperCase() || !/[A-Z]/.test(name)) return name;
  return name
    .toLowerCase()
    .split(" ")
    .map((word) => (/\d/.test(word) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(" ");
}

export function leadTime(days: { min: number; max: number }) {
  return days.min === days.max ? `${days.min} days` : `${days.min}–${days.max} days`;
}

/** Storefront price: drops ".00" on whole-peso prices (₱299), keeps centavos when they matter (₱14.99). Checkout keeps full formatMoney. */
export function shortMoney(centavos: number) {
  return new Intl.NumberFormat("en-PH", {
    style: "currency", currency: "PHP", minimumFractionDigits: centavos % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
  }).format(centavos / 100);
}
